<template>
  <div>
    <RevTag v-if="badge" :label="badge" variant="info" />

    <component :is="headingType" id="cms-heading-title" :class="headingClasses">
      {{ title }}
    </component>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { BannerTextColor } from '@backmarket/http-api/src/api-specs-content/models/banner'
import { tw } from '@backmarket/utils/string/tw'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { RevTag } from '@ds/components/Tag'

import { getBannerTextColorClass } from '../../helpers/banner/getTextColor'

const props = withDefaults(
  defineProps<{
    title?: Maybe<string>
    badge?: Maybe<string>
    textColor?: BannerTextColor
    size?: Maybe<'medium' | 'large'>
    headingType?: 'h1' | 'p'
  }>(),
  {
    title: '',
    textColor: BannerTextColor.Black,
    badge: '',
    size: 'medium',
    headingType: 'h1',
  },
)

const headingClasses = computed(() => {
  return [
    getBannerTextColorClass(props.textColor),
    props.size === 'medium' ? tw`heading-1` : tw`punchline`,
  ]
})
</script>
